import { TeacherProps } from './TeacherInterface';
import { FiMoreVertical, FiX } from 'react-icons/fi';
import '../../component/ProfileCard/ProfileCard.style.scss';
import { HiOutlineMail } from 'react-icons/hi';
import { MdOutlineLocalPhone, MdEditLocationAlt } from 'react-icons/md';
import { TeacherDetailsModal } from './TeacherDetailsModal';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { ConfirmDeleteToast } from '../../utils/Helper';
import { TeacherEdit } from './TeacherEdit';
import { AssignSubject } from './AssignSubject.dialog ';
import { truncateText } from '../../lib/textTrunclate';
import './Teacher.style.scss';

interface TeacherCardProps {
  item: TeacherProps;
  index: number;
  openMenuIndex: number | null;
  setOpenMenuIndex: React.Dispatch<React.SetStateAction<number | null>>;
  deleteTeacher: (teacherId: string | number) => void;
  onTeacherUpdate: any;
  teachers?: TeacherProps[];
}

export const TeacherCard: React.FC<TeacherCardProps> = ({
  item,
  index,
  openMenuIndex,
  setOpenMenuIndex,
  deleteTeacher,
  onTeacherUpdate,
  teachers,
}) => {
  const fullname = item ? item.first_name + ' ' + item.last_name : 'ABC ZYX';
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [assignableTeacher, setAssignableTeacher] =
    useState<TeacherProps | null>(null);

  const [editTeacherForm, setEditTeacherForm] = useState<boolean>(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setOpenMenuIndex(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const teacherDetails = {
    id: item.id,
    first_name: item.first_name,
    last_name: item.last_name,
    email: item.email,
    phone_number: item.phone_number,
    profile_photo: item.profile_photo || '',
    address: item.address || '',
    subjects: item.subjects || 'No subjects available',
  };

  const editTeacherFormData = {
    id: item.id,
    first_name: item.first_name,
    last_name: item.last_name,
    email: item.email,
    phone_number: item.phone_number,
    address: item.address,
    profile_photo: item.profile_photo ?? null,
  };

  const handleToggleMenu = () => {
    setOpenMenuIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const openTeacherEditForm = () => {
    setEditTeacherForm(true);
    setOpenMenuIndex(null);
  };

  const closeTeacherEditForm = () => {
    setEditTeacherForm(false);
    setOpenMenuIndex(null);
  };

  const resetOpenModal = () => {
    setEditTeacherForm(false);
    setOpenMenuIndex(null);
  };

  const handleDeleteClick = () => {
    toast(t => (
      <ConfirmDeleteToast
        onConfirm={() => {
          resetOpenModal();
          deleteTeacher(item.id);
          toast.dismiss(t.id);
        }}
        onCancel={() => toast.dismiss(t.id)}
        message={`Are you sure you want to delete ${fullname}?`}
      />
    ));
  };

  const handleTeacherUpdate = (updatedTeacherData: TeacherProps) => {
    onTeacherUpdate(updatedTeacherData);
    console.log(updatedTeacherData, 'child update receive');
  };

  return (
    <>
      <div className="profile_card teacher_profile_card">
        <div className="action_menu">
          <FiMoreVertical
            className="cursor-pointer"
            onClick={handleToggleMenu}
          />
        </div>
        {openMenuIndex === index && (
          <div className="dropdown-menu">
            <ul>
              <li className="cursor-pointer" onClick={openTeacherEditForm}>
                Edit
              </li>
              <li
                className="cursor-pointer"
                onClick={() => {
                  setAssignableTeacher(item);

                  setOpenMenuIndex(null);
                }}
              >
                Assign
              </li>
              <li className="cursor-pointer" onClick={handleDeleteClick}>
                Delete
              </li>
            </ul>
          </div>
        )}
        <div className="profile_image">
          {item.profile_photo ? (
            <img src={item.profile_photo} alt={fullname} />
          ) : (
            <> </>
          )}
          {/* <img src={`${item.profile_photo}`} alt={fullname} /> */}
        </div>
        <div className="profile_info">
          <div className="name_subject">
            <h2 onClick={handleOpenModal} className="cursor-pointer">
              {truncateText(fullname)}
            </h2>
          </div>

          <div className="teacher_contact">
            <div className="teacher_contact__row" title={item.email}>
              <HiOutlineMail className="teacher_contact__icon" aria-hidden />
              <span className="teacher_contact__text">{item.email}</span>
            </div>
            {item.phone_number ? (
              <div className="teacher_contact__row" title={item.phone_number}>
                <MdOutlineLocalPhone
                  className="teacher_contact__icon"
                  aria-hidden
                />
                <span className="teacher_contact__text">{item.phone_number}</span>
              </div>
            ) : null}
            {item.address ? (
              <div className="teacher_contact__row" title={item.address}>
                <MdEditLocationAlt
                  className="teacher_contact__icon"
                  aria-hidden
                />
                <span className="teacher_contact__text">
                  {item.address}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <TeacherDetailsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          teacher={teacherDetails}
        />
      )}

      {editTeacherForm && (
        <TeacherEdit
          isOpen={editTeacherForm}
          onClose={closeTeacherEditForm}
          teacher={editTeacherFormData}
          onTeacherUpdate={handleTeacherUpdate}
        />
      )}

      {assignableTeacher?.id && (
        <AssignSubject
          isOpen={!!assignableTeacher?.id}
          onClose={() => setAssignableTeacher(null)}
          teacher={assignableTeacher}
        />
      )}
    </>
  );
};
